module.exports = __webpack_public_path__ + "img/map_Z5.4.C.06.b2df1952.svg";